import React from 'react'
import { Helmet, } from 'react-helmet'

export const pageTitle = 'Tourplanr'
export const pageTitleSeparator = ' | '
export const pageTitlePrefix = `${pageTitle}${pageTitleSeparator}`

export function renderAppHelmet() {
  return (
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
  )
}

export function renderTripPageHelmet({ viewingTripEvent, managingTrip, eventName, tripName, }) {
  if (managingTrip) {
    return (
      <Helmet>
        <title>{pageTitlePrefix}Manage Trip</title>
      </Helmet>
    )
  } else if (viewingTripEvent && eventName) {
    return (
      <Helmet>
        <title>{pageTitlePrefix}{tripName}{pageTitleSeparator}{eventName}</title>
      </Helmet>
    )
  }
  return (
    <Helmet>
      <title>{pageTitlePrefix}{tripName}</title>
    </Helmet>
  )
}



// WEBPACK FOOTER //
// ./src/lib/pageHelmet.js